module.exports = __webpack_public_path__ + "static/media/keywords_packing.27d13af2.JPG";